module.exports = __webpack_public_path__ + "img/ic_light_red.dd61be7c.png";